module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_duo_cp_gaseosas_pet_500_ccso.9125916e.png";